<template>
  <div>
    <template v-if="isHeaderVisible">
      <ErrorBoundary>
        <client-only>
          <Notifications />
        </client-only>
      </ErrorBoundary>

      <header>
        <NuxtLink to="/">
          <NuxtImg
            :src="headerLogo"
            alt="Konfetti"
            class=""
            :class="{ '!h-14': subdom }"
          />
        </NuxtLink>
      </header>
    </template>
    <slot />
  </div>
</template>
<script setup lang="ts">
const route = useRoute()
const isHeaderVisible = computed(() => route.meta.isHeaderVisible ?? false)

const subdom = useSubdomain()
const { data: partnerData } = subdom.value
  ? useSubdomainData()
  : { data: ref(undefined) }

const partnerDataComputed = computed(() => {
  /* if partner has no logo default domain will be shown */
  return {
    logo: supplierGetters.getHeaderLogo(partnerData.value) || undefined,
    permalink: supplierGetters.getPermalink(partnerData.value),
  }
})

const headerLogo = computed(
  () =>
    (route?.meta?.headerLogo as string) ??
    partnerDataComputed.value.logo ??
    '/_nuxt3-static/logos/logo.svg'
)
</script>

<style scoped lang="postcss">
header {
  @apply h-[74px] flex items-center justify-center border-gray-100 border-b;

  img {
    @apply h-[25px];
  }
}
</style>

<style>
.Toastify__toast-container {
  max-width: 480px;
  --toastify-toast-width: max-content;
}
</style>
